"use client";

import { c as _c } from "react/compiler-runtime";
import ConstructionIcon from "@/assets/icons/construction.svg";
import { cn } from "@/lib/utils";
export type ComingSoonStateProps = {
  /** Page or feature name (e.g. "Reports", "Analytics Dashboard") */
  title?: string;
  /** Optional secondary message */
  description?: string;
  /** Optional custom icon (defaults to Construction) */
  icon?: React.ReactNode;
  /** Additional class names for the container */
  className?: string;
};
export function ComingSoonState(t0) {
  const $ = _c(16);
  const {
    title: t1,
    description: t2,
    icon,
    className
  } = t0;
  const title = t1 === undefined ? "Will be Available Soon" : t1;
  const description = t2 === undefined ? "We're working hard to bring you this feature. Please check back later." : t2;
  let t3;
  if ($[0] !== className) {
    t3 = cn("flex flex-col items-center justify-center min-h-[60vh] py-16 px-6 text-center", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== icon) {
    t4 = icon ?? <ConstructionIcon className="size-16 text-brand-orange" aria-hidden={true} />;
    $[2] = icon;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <div className="rounded-full bg-brand-orange/10 border-2 border-brand-orange/30 p-6 mb-6">{t4}</div>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== title) {
    t6 = <h2 className="text-2xl font-bold text-gray-700 mb-3">{title}</h2>;
    $[6] = title;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== description) {
    t7 = <p className="text-muted-foreground max-w-md text-base leading-relaxed">{description}</p>;
    $[8] = description;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="mt-8 flex items-center gap-2 text-sm text-muted-foreground"><span className="inline-flex h-2 w-2 rounded-full bg-brand-orange animate-pulse" /><span>Coming soon</span></div>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t3 || $[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
    t9 = <div className={t3}>{t5}{t6}{t7}{t8}</div>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}